import React, { useState } from "react";
import _ from "lodash";
import "./styles/update-cover.css";
// @ts-ignore
import ReactS3Uploader from "react-s3-uploader";
import { PageConfiguration, Event } from "./index";
import ajax from "superagent";
import { OrganizationHeaderContextConsumer } from "./CustomizeLandingPage";

const closeIcon = require("./styles/remove.svg");

const UpdateEventCoverPopup = ({
  event,
  closePopup,
  updateEventCover
}: {
  event: Event;
  closePopup: () => void;
  updateEventCover: Function
}) => {
  const [imageProcessing, setImageProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [coverPhotoUrl, setCoverPhotUrl] = useState<string | null>(
    event.coverPhoto || null
  );

  const imageSelected = (file: any, next: Function) => {
    setImageProcessing(true);
    next(file);
  };

  const getSignedUrl = (file: any, callback: Function) => {
    ajax
      .get("/s3/signed_url")
      .query({
        objectName: file.name,
        contentType: file.type
      })
      .then(data => {
        callback(JSON.parse(data.text));
      })
      .catch(error => {
        console.error(error);
      });
  };
  return (
    <OrganizationHeaderContextConsumer>
      {context =>
        context && (
          <div>
            <div
              id="update-cover-dialog"
              className="modal fade in geo-modal geo-modal--scroll"
              role="dialog"
            >
              <div className="modal-dialog modal-lg update-cover-dialog-content">
                <div className="update-cover-dialog-header">
                  <button className="close"onClick={closePopup}>
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <p className="update-cover-heading-p1">
                    Upload a cover image
                  </p>
                  <p className="update-cover-heading-p2">
                    for{" "}
                    <span className="update-cover-ev-title">{event.name}</span>,{" "}
                    {event.location}
                  </p>
                </div>
                <div className="update-cover-content-div">
                  {coverPhotoUrl ? (
                    <React.Fragment>
                      <div
                        className="cover-photo-preview"
                        style={{
                          height: "186px"
                        }}
                      >
                        <div
                          style={{
                            backgroundImage: `url("${coverPhotoUrl}")`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "top",
                            width: "100%",
                            height: "100%"
                          }}
                        ></div>
                      </div>
                      <a
                        className="btn btn-xs cover-photo-remove-btn"
                        onClick={() => setCoverPhotUrl(null)}
                      >
                        Remove Image
                      </a>
                    </React.Fragment>
                  ) : (
                    <div className="cover-upload-section">
                      <label className="btn btn-primary cover-upload-btn">
                        {imageProcessing ? progress + "%" : "Upload an image"}
                        <ReactS3Uploader
                          className={"dv-upload-input"}
                          style={{ display: "none" }}
                          getSignedUrl={(file: any, callback: any) => {
                            ajax
                              .get("/s3/signed_url")
                              .query({
                                bucket: context.coversS3Bucket,
                                objectKey: `${context.eventCoverS3BasePath}/${event.id}/${file.name}`,
                                contentType: file.type
                              })
                              .then(data => {
                                callback(JSON.parse(data.text));
                              })
                              .catch(error => {
                                console.error(error);
                              });
                          }}
                          accept="image/*"
                          preprocess={imageSelected}
                          onProgress={(completedPercent: number) => {
                            setImageProcessing(true);
                            setProgress(completedPercent);
                          }}
                          onError={console.error}
                          onFinish={(result: any) => {
                            setImageProcessing(false);
                            setCoverPhotUrl(result.signedUrl.split("?")[0]);
                          }}
                          uploadRequestHeaders={{
                            "x-amz-acl": "public-read"
                          }}
                          scrubFilename={(filename: string) =>
                            filename.replace(/[^\w\d_\-.]+/gi, "")
                          }
                          contentDisposition="auto"
                        />
                      </label>
                      <p className="org-upload-p2">Min size: 310px x 175px</p>
                    </div>
                  )}
                </div>
                <div className="cover-from-event">
                  <a
                    href={`${event.eventCoverPhotoPickerPath}?return_to=${window.location.pathname}`}
                    className={"active"}
                    data-toggle="tooltip"
                    aria-hidden="true"
                    title={"Go to gallery"}
                  >
                    Select from event photos{" "}
                    <i className="fa fa-chevron-right"></i>
                  </a>
                </div>
                <div className="update-cover-dialog-footer">
                  <button
                    className="update-cover-apply-btn btn-round btn-primary btn-sm pull-right"
                    onClick={_ => {
                      updateEventCover(event.id, coverPhotoUrl);
                      closePopup();
                    }}
                  >
                    {" "}
                    Update
                  </button>

                  <a className="update-cover-cancel-btn" onClick={closePopup}>
                    {" "}
                    Cancel
                  </a>
                </div>
              </div>
            </div>
            <div className="modal-backdrop fade in" />
          </div>
        )
      }
    </OrganizationHeaderContextConsumer>
  );
};

export default UpdateEventCoverPopup;
